<template>
  <section style="width: 100%" v-if='loaded'>
    <v-layout row>
      <v-flex xs12>
        <v-btn color="primary" dark class="my-3" v-if="isWriteAvailable" @click="open">Add Package</v-btn>
          <v-flex xs2>
            <v-text-field
              append-icon="search"
              label="Search by id"
              v-model="search.id"
            />
          </v-flex>
        <!-- remove v-if="hasPackages" add prop for package component -->
        <package
          v-for="(packageData, packageIndex) in packages"
          :key="`package-id-${packageData.id}`"
          :packageData="packageData"
          :packageIndex="packageIndex"
          :hasPackages="hasPackages"
          :class="{'mb-3': packages.length - 1 !== packageIndex }"
          @successSendPackage="fetchPackages"
        />
      </v-flex>
    </v-layout>
    <package-modal
      v-if="isOpen"
      :showModal="isOpen"
      @close="closeModal"
      @successSendPackage="fetchPackages"
    />
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { clone } from 'ramda'
  import mixins from '@/utils/mixins'
  import Package from './package.vue'
  import PackageModal from './packageModal.vue'

  export default {
    name: 'Packages',
    mixins: [mixins.isWriteAvailable, mixins.emailTemplates],
    components: {
      Package,
      PackageModal
    },
    data () {
      return {
        loaded: false,
        hasPackages: false,
        isOpen: false,
        packages: null,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write',
        search: {
          id: ''
        }
      }
    },
    computed: {
      ...mapGetters([
        'packagesList'
      ])
    },
    watch: {
      search: {
        handler () {
          this.getPackages()
        },
        deep: true
      },
      getPackagesList: {
        handler (val) {
          this.packages = clone(val)
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions([
        'getPackagesList',
        'getPredefinedActivity',
        'fetchUsers',
        'fetchEmailTemplates',
        'showResultSuccessMessage',
        'showResultErrorMessage'
      ]),
      open () {
        this.isOpen = true
      },
      closeModal () {
        this.isOpen = false
      },
      fetchPackages () {
        this.getPackages()
      },
      async getPackages () {
        try {
          await this.getPackagesList(this.search)
          this.packagesList.length > 0
            ? this.hasPackages = true
            : this.hasPackages = false
          if (this.hasPackages) this.packages = clone(this.packagesList)
        } catch (err) {
          this.showResultErrorMessage(err.message)
        }
      }
    },
    async created () {
      try {
        await Promise.all([
          this.getPackages(),
          this.getPredefinedActivity({ page: 0, itemsOnPage: 99999 }),
          this.fetchUsers({ page: 0, itemsOnPage: 99999 })
        ])
        this.loaded = true
      } catch (err) {
        this.showResultErrorMessage(err.message)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Packages/packageList.vue